'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { EditorMode } from '@/msgdeskRuntime/contracts/editorActions'

export interface EditorSessionIdentity {
  mode: EditorMode
  isMsg: boolean | undefined
}

export const closedEditorSession: EditorSessionIdentity = {
  mode: '',
  isMsg: undefined,
}

const EditorSessionContext = createContext<EditorSessionIdentity | null>(null)

export function EditorSessionProvider({
  value,
  children,
}: {
  value: EditorSessionIdentity
  children: ReactNode
}) {
  return <EditorSessionContext.Provider value={value}>{children}</EditorSessionContext.Provider>
}

/**
 * One React-owned identity for the active editor session. Form values still
 * come from the rough projection; mode/entity identity comes directly from
 * the editor-open boundary so an updated answer is not collapsed into the
 * ambiguous legacy `update_msg` mode.
 */
export function useEditorSession(): EditorSessionIdentity {
  const value = useContext(EditorSessionContext)
  if (!value) throw new Error('Editor session seam missing around MsgDesk page')
  return value
}
